import {Component, effect, Input, OnInit} from '@angular/core';
import {MainStoreService} from "@cybfed/core/store/main.store.service";
import {CommonModule} from "@angular/common";
import {ProductService} from "@cybfed/core/services/marketplace/product.service";
import {TranslateModule} from "@ngx-translate/core";
import {StorageService} from "@cybfed/core/services/storage.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {SingleStepComponent} from "@cybfed/shared/components/stepper-slider/single-step/single-step.component";
import {StepperSliderComponent} from "@cybfed/shared/components/stepper-slider/stepper-slider.component";
import {
    DonationWidgetItemComponent
} from "@white-label/components/page-builder/widgets/donation-widget/donation-widget-item/donation-widget-item.component";
import {
    DonationWidgetFormComponent
} from "@white-label/components/page-builder/widgets/donation-widget/donation-widget-form/donation-widget-form.component";
import {TopupService} from "@cybfed/core/services/topup.service";
import {PackageService} from "@cybfed/core/services/package.service";
import {FileUploadService} from "@cybfed/core/services/file-upload.service";
import {DonationWidgetModel} from "@white-label/components/page-builder/models/donation-widget.model";
import {
    DonationWidgetStickersComponent
} from "@white-label/components/page-builder/widgets/donation-widget/donation-widget-stickers/donation-widget-stickers.component";
import {BackTranslatePipe} from "@cybfed/shared/pipes/back-translate.pipe";
import {InputComponent} from "@cybfed/ui-lib/forms/text-inputs/input/input.component";
import {TextareaComponent} from "@cybfed/ui-lib/forms/textarea/textarea.component";
import {PopupHelperService} from "@cybfed/core/services/popup-helper.service";
import {Ga4Service} from "@cybfed/core/helpers/ga4.service";
import {
    DonationWidgetYoutubeLinkComponent
} from "@white-label/components/page-builder/widgets/donation-widget/donation-widget-youtube-link/donation-widget-youtube-link.component";

@Component({
    selector: 'app-donation-widget',
    templateUrl: './donation-widget.component.html',
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        SingleStepComponent,
        StepperSliderComponent,
        DonationWidgetItemComponent,
        DonationWidgetFormComponent,
        DonationWidgetStickersComponent,
        BackTranslatePipe,
        InputComponent,
        TextareaComponent,
        DonationWidgetYoutubeLinkComponent,
    ],
    providers: [
        ProductService,
        TopupService,
        PackageService,
        FileUploadService,
    ]
})
export class DonationWidgetComponent implements OnInit {

    public stickers:any = [];
    public prices!: number[];
    currentUser: any;
    session: any;
    whiteLabel: any;
    form!: FormGroup; // Reactive form group
    stepJson:any = {
        showStep: 0
    }
    public courseOnSelectedCurrency: number = 1;
    public productServices: any[] = []
    public stickersEnabled: boolean = false;


    constructor(public mainStore: MainStoreService,
                private productService: ProductService,
                private popupHelperService: PopupHelperService,
                private ga4Service: Ga4Service,
                private fb: FormBuilder,) {
        effect(() => {
            if(this.mainStore.whiteLabel){
                this.whiteLabel = this.mainStore.whiteLabel;
                this.setStoreChange();
            }
        });
    }

    ngOnInit() {
        this.currentUser = StorageService.getJsonItem(StorageService.statics.currentUser);
        this.initializeForm();
        this.setStoreChange();

        this.getStickerProduct()

    }

    setStoreChange(){
        this.prices = [];
        let minPrice = 200;
        if (this.mainStore?.whiteLabel?.donationWidgetConfig){
            if (this.mainStore?.whiteLabel?.donationWidgetConfig.minPrice && this.mainStore?.whiteLabel?.donationWidgetConfig.minPrice) {
                minPrice = this.mainStore?.whiteLabel?.donationWidgetConfig.minPrice;
            }
        }
        this.prices.push(minPrice)
        for(let key = 1; key < 4; key++) {
            this.prices.push(this.prices[key-1]  * 5)
        }
    }

    getStickerProduct(){
        // this.productService.getStickersProduct( {currency: this.form.get('currency')?.value}).subscribe((data: any) =>{
        //     if(!data.hasError){
        //         if (data.data.stickerProduct.status === 'inactive') {
        //             this.stickersEnabled = false;
        //         }else {
        //             this.stickersEnabled = true;
        //             this.stickers = data.data.stickerProduct.services;
        //             this.courseOnSelectedCurrency = data.data.courseCurrency
        //         }
        //
        //
        //
        //         // Initialize the form dynamically
        //
        //     }
        // })


    }

    initializeForm() {
        const controlsConfig: any = {
            email: [
                this.currentUser?.email || null,
                [ Validators.email]
            ],
            count: [1, [Validators.required, Validators.min(1), Validators.max(100)]],
            name:  [this.currentUser?.nickname || 'Anonymous'],
            currency:  [this.mainStore.whiteLabel.currency, Validators.required ],
            price:  [0, Validators.required ],
            tip:  [0],
            description:  [''],
            media: [null],
            metaData: [{}],
            donationInfo: [{}],
            requiredFields: this.fb.group({}) // Initialize as a FormGroup
        };

        this.form = this.fb.group(controlsConfig);
    }

    donate() {

    }

    nextStep(event: any| undefined = null) {
        if(event.type === 'finishDonate'){
            this.popupHelperService.printSuccess()
            this.ga4Service.trackEvent('donate', {
                type: event.type,
                step: 3,
                session: this.session,
                data: this.form.value,
            })
            this.form.reset();
            this.stepJson.showStep = 0;
            this.productServices = [];
            this.stickers = null;
            this.session = null;
            this.initializeForm();
            return;
        }
        this.form.controls["metaData"].patchValue({
            ...this.form.controls["metaData"].value,
            username:  this.form.controls["name"].value,
            message: this.form.controls["description"].value
        });
        if (event.type === 'sticker') {
            this.form.controls["metaData"].patchValue({
                ...this.form.controls["metaData"].value,
                type: 'sticker'
            });
            this.stepJson.showStep = 1
        }else if (event.type === 'notification') {
            this.form.controls["metaData"].patchValue({
                ...this.form.controls["metaData"].value,
                type: 'notification'
            });
            this.form.controls["tip"].patchValue(this.form.value.price);
            this.form.controls["price"].patchValue(0);
            this.stepJson.showStep = 2
        }else if (event.type === 'donate') {
            this.form.controls["metaData"].patchValue({
                ...this.form.controls["metaData"].value,
                type: 'donate'
            });
            this.form.controls["tip"].patchValue(this.form.value.price);
            this.form.controls["price"].patchValue(0);
            this.stepJson.showStep = 2
        }else if (event.type === 'crowdfunding') {
            this.form.controls["metaData"].patchValue({
                ...this.form.controls["metaData"].value,
                type: 'crowdfunding'
            });
            this.form.controls["tip"].patchValue(this.form.value.price);
            this.form.controls["price"].patchValue(0);
            this.stepJson.showStep = 2
        }else if (event.type === 'youtube_link') {
            this.form.controls["metaData"].patchValue({
                ...this.form.controls["metaData"].value,
                type: 'youtube_link'
            });
            this.form.controls["tip"].patchValue(Math.max(this.form.value.price, this.form.value.tip) );
            this.form.controls["price"].patchValue(0);
            this.stepJson.showStep = 3
        }
        this.session = Date.now();
        this.ga4Service.trackEvent('donate', {
            type: event.type,
            step: this.stepJson.showStep,
            session: this.session,
            data: this.form.value,
        })
    }

    prevStep(){
        this.stepJson.showStep = 0;
    }


    makeOrder(data: any) {
        this.productServices = data.selectedStickers
        let selectedServicesPrice = data.totalPrice;
        let price = this.form.get('price')?.value | 0
        if (price > selectedServicesPrice) {
            this.form.controls["tip"].patchValue(price - selectedServicesPrice);
            this.form.controls["price"].patchValue(selectedServicesPrice);
        }else{
            this.form.controls["price"].patchValue(selectedServicesPrice);
        }
        let metaData = this.form.value.metaData;
        metaData = {...metaData, animation: data.selectedAnimation};
        this.form.controls["metaData"].patchValue(metaData);
        this.stepJson.showStep = 2;

        this.ga4Service.trackEvent('donate', {
            type: 'sticker',
            step: this.stepJson.showStep,
            tip: this.stepJson.showStep,
            session:  this.session,
            username:  this.form.controls["name"].value,
            message: this.form.controls["description"].value,
            data: this.form.controls["metaData"].value,
        })
    }


    setYoutubeLink(event: any) {
        let metaData = this.form.value.metaData;
        metaData = {...metaData, ...event};
        this.form.controls["metaData"].patchValue(metaData);
        this.stepJson.showStep = 2;

    }
}
